import { Injectable } from "@angular/core";
import { HttpClient, HttpContext } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { SKIP_ERROR_ALERT } from "../../shared/interceptors/skip-error-alert.context";
import { Announcement, AnnouncementInboxItem, AnnouncementSeenRequest, ApiResponse } from "./announcement.models";

/**
 * Runtime read/seen calls the app shell uses — mirrors the Java AnnouncementClientApi
 * (/v1/api/announcement-client, no role gate beyond authentication).
 */
@Injectable({ providedIn: "root" })
export class AnnouncementClientApiService {
  private readonly baseUrl = `${environment.wabaApiUrl}/v1/api/announcement-client`;

  constructor(private http: HttpClient) {}

  /** Unseen, active, audience-matched announcements — drives the auto-popup on app open. */
  bootstrap(): Observable<ApiResponse<Announcement[]>> {
    return this.http.get<ApiResponse<Announcement[]>>(`${this.baseUrl}/bootstrap`);
  }

  /** Everything still active/persistent regardless of seen-state — the header "what's new" icon list. */
  inbox(): Observable<ApiResponse<AnnouncementInboxItem[]>> {
    return this.http.get<ApiResponse<AnnouncementInboxItem[]>>(`${this.baseUrl}/inbox`);
  }

  /** Background read-tracking: a failure here is never the user's business, so no error toast. */
  markSeen(slug: string, request: AnnouncementSeenRequest): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.baseUrl}/${slug}/seen`, request, {
      context: new HttpContext().set(SKIP_ERROR_ALERT, true),
    });
  }
}
